/**
 * Format an integer öre value to Swedish SEK display string.
 * 3483300 öre → "34 833 kr"
 */
export function formatSEK(ore: number): string {
  const kr = ore / 100;
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(kr);
}

/**
 * Format a Date or ISO string to YYYY-MM-DD.
 */
export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toISOString().substring(0, 10);
}

/**
 * Format a month number (1-12) to Swedish month name.
 */
export function formatMonthName(month: number): string {
  const date = new Date(2024, month - 1, 1);
  return date.toLocaleString('sv-SE', { month: 'long' });
}

/**
 * Convert SEK string from user input (e.g. "1 250,50") to öre integer.
 */
export function parseSEKToOre(value: string): number {
  const normalized = value.replace(/\s/g, '').replace(',', '.');
  const kr = parseFloat(normalized);
  if (Number.isNaN(kr)) return 0;
  return Math.round(kr * 100);
}
